(function (window, TL, undefined) {
    'use strict';

    var app,
        fn = {},
        _fn = {},
        cf = {
            ss_urls: {
                production:  'https://docs.google.com/spreadsheets/d/1qQbHM8klpyio9bVJoFnBUlYov2dgehNeEHtwylYMiCo/pubhtml',
                internal:    'https://docs.google.com/spreadsheets/d/1R3drjOxxpRk-fVdhAMIik8LGSbwHjlRaKwnCbdHXGxw/pubhtml',
                development: 'https://docs.google.com/spreadsheets/d/1EahGHZ-0txq5jELCd3b7vVaJq-HKnk4fL5WlzBlTQ88/pubhtml',
                preview:     'https://docs.google.com/spreadsheets/d/13iaJOvtkwMmK7CeJ-hl6hmHj6adtdFa1xlGAUek0kP4/pubhtml',
            }
        },
        st = {},
        tl,
        data = [],
        console;

    fn.init = function () {
        var options;

        console = window.console;
        // console.log('timeline.init called.');

        options = {
            fixTimenavHeight: true
        };
        tl = new TL.Timeline(
            'timeline',
            cf.ss_urls[st.env],
            options
        );
        var selectedCategories = _fn.getSelectedCategories();

        _fn.changeCheckboxState(selectedCategories);

        var removeCategories = _fn.getRemoveCategories(selectedCategories);

        _fn.initTlConfigEvents(removeCategories);
        var $a = $('div.timeline-filter-btn > .btn');
        var $checkbox = $('[type=checkbox]');

        $checkbox.change(function () {
            _fn.onCheckboxChange($a);
        });

        data = tl.getDataAll();

        tl.on('change', function (e) {
            window.timelinemap.manager.onTimelineChange(e);
        });
    };

    _fn.onCheckboxChange = function ($a) {
        var hrefUrl = [];
        var params = [];
        var paramsFlag = false;

        hrefUrl.push('./');

        if ($('[name=aurora]').prop('checked')) {
            params.push('aurora');
            paramsFlag = true;
        }
        if ($('[name=supernova]').prop('checked')) {
            params.push('supernova');
            paramsFlag = true;
        }
        if ($('[name=comet]').prop('checked')) {
            params.push('comet');
            paramsFlag = true;
        }
        if ($('[name=meteor]').prop('checked')) {
            params.push('meteor');
            paramsFlag = true;
        }
        if ($('[name=earthquake]').prop('checked')) {
            params.push('earthquake');
            paramsFlag = true;
        }
        if ($('[name=other]').prop('checked')) {
            params.push('other');
            paramsFlag = true;
        }
        if (paramsFlag) {
            hrefUrl.push('?category=');
        }
        hrefUrl.push(params.join('+'));
        $a.attr('href', hrefUrl.join(''));
    };

    _fn.getSelectedCategories = function () {
        var search = window.location.search;
        if (search !== '') {
            var kv = search.slice(1);
            var pair = kv.split('=');
            var k = pair[0];
            var v = pair[1];

            if (k === 'category') {
                var params = {};
                params[k] = v.split('+');
                return params[k];
            }
        }
        return [];
    };

    _fn.changeCheckboxState = function (selectedCategories) {
        for (var i = 0; i < selectedCategories.length; i += 1) {
            var $checkbox = $('[name=' + selectedCategories[i] + ']');
            $checkbox.prop('checked', true);
        }
    };

    _fn.getRemoveCategories = function (selectedCategories) {
        var removeCategories = [];

        var categories = [
            'aurora',
            'supernova',
            'comet',
            'meteor',
            'earthquake',
            'other',
        ];

        for (var i = 0; i < selectedCategories.length; i += 1) {
            if (selectedCategories.length !== 0) {
                var idx = categories.indexOf(selectedCategories[i]);
                categories.splice(idx, 1);
                removeCategories = categories.concat('');
            }
        }
        return removeCategories;
    };

    _fn.initTlConfigEvents = function (removeCategories) {
        var count = tl.config.events.length;
        var j = 0;
        for (var i = 0; i < count; i += 1) {
            if (removeCategories.indexOf(tl.config.events[j].category) !== -1) {
                tl.removeId(tl.config.events[j].unique_id);
            } else {
                j += 1;
            }
        }
    };

    fn.moveTimelineTo = function (id) {
        // tl.goToIdを実行するpublicメソッドを実装
        tl.goToId(id);
    };

    fn.getDataAll = function () {
        // titleオブジェクトを含む配列を返す
        return data;
    };

    fn.updateDisplay = function () {
        tl.updateDisplay();
    };

    app = function (prop) {
        var app,
            m;

        st.env = prop.env;

        app = {};
        for (m in fn) {
            app[m] = fn[m];
        }
        return app;
    };

    window.timelinemap = window.timelinemap || {};
    window.timelinemap.fn = window.timelinemap.fn || {};
    window.timelinemap.fn.timeline = app;

}(this, TL));
